module.exports = __webpack_public_path__ + "img/EDC8601_1-1.efbb7ede.png";